import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAward, FiUsers, FiTrendingUp } = FiIcons;

const CultureROI = () => {
  const cards = [
    {
      icon: FiAward,
      title: "Appreciation",
      desc: "Show your team the year mattered with an experience that feels like a true reward."
    },
    {
      icon: FiUsers,
      title: "Connection",
      desc: "Bring departments, leadership, and staff together in a warm, inviting atmosphere."
    },
    {
      icon: FiTrendingUp,
      title: "Morale",
      desc: "End the year with positive energy that people carry forward into the next one."
    }
  ];

  return (
    <section className="py-32 bg-spanish-ivory relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <motion.h2 
            className="font-serif text-4xl md:text-5xl text-mission-green mb-6 relative inline-block"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Your Team Remembers How the Year Ended
            <div className="h-0.5 w-24 bg-antique-gold mx-auto mt-4"></div>
          </motion.h2>
          <motion.p 
            className="text-mission-green/80 text-lg leading-relaxed mt-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            A thoughtful holiday party does more than fill a calendar date. It gives leadership a moment to recognize the people behind the work and strengthen morale.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          {cards.map((card, idx) => (
            <motion.div 
              key={idx}
              className="bg-spanish-ivory p-10 rounded-lg border border-olive-sage/30 text-center hover:shadow-xl hover:border-antique-gold/50 transition-all duration-500 group"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 * idx }}
            >
              <div className="w-16 h-16 bg-limestone-warm rounded-full flex items-center justify-center mx-auto mb-8 text-antique-gold group-hover:bg-mission-green group-hover:text-spanish-ivory transition-colors duration-500">
                <SafeIcon icon={card.icon} className="text-3xl" />
              </div>
              <h3 className="font-serif text-2xl text-mission-green mb-4">{card.title}</h3>
              <p className="text-mission-green/70 text-base leading-relaxed">{card.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CultureROI;